export default function loadingIcon2() {
   return (
      <div className="loadingIcon2 flex flex-ai-c flex-jc-c">
         <i className="animate-spin icon-spin6"></i>
      </div>
   );
}